document.addEventListener('DOMContentLoaded', function() {
    // Get all elements with the class 'lpi-content'
    const lpiContents = document.querySelectorAll('.lpi-content');

    lpiContents.forEach(content => {
        content.addEventListener('click', function() {
            // Get the parent '.lpi-item' of the clicked content
            const currentItem = this.closest('.lpi-item');
            
            // Check if the clicked item is already active
            const isActive = currentItem.classList.contains('active');
            
            // Remove the 'active' class from all items
            document.querySelectorAll('.lpi-item').forEach(item => {
                item.classList.remove('active');
            });

            // Toggle the 'active' class on the clicked item's parent if it was not already active
            if (!isActive) {
                currentItem.classList.add('active');
            }
        });
    });
});

$('.pw-slider .owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots: true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:2
        }
    }
})

$('.ingradients-slider .owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots: true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:3
        }
    }
})
